import { render, staticRenderFns } from "./UsersActivities.vue?vue&type=template&id=ab7f390a&scoped=true&"
import script from "./UsersActivities.vue?vue&type=script&setup=true&lang=js&"
export * from "./UsersActivities.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7f390a",
  null
  
)

export default component.exports